import { render, staticRenderFns } from "./AnnotationPreview.vue?vue&type=template&id=2f9d0028&scoped=true"
import script from "./AnnotationPreview.vue?vue&type=script&lang=js"
export * from "./AnnotationPreview.vue?vue&type=script&lang=js"
import style0 from "./AnnotationPreview.vue?vue&type=style&index=0&id=2f9d0028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d0028",
  null
  
)

export default component.exports